import { render, staticRenderFns } from "./myLove.vue?vue&type=template&id=4a1582f6&scoped=true&"
import script from "./myLove.vue?vue&type=script&lang=js&"
export * from "./myLove.vue?vue&type=script&lang=js&"
import style0 from "./myLove.vue?vue&type=style&index=0&id=4a1582f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1582f6",
  null
  
)

export default component.exports